export const getAvatarStyles = customStyles => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  flexShrink: 0,
  width: '33px',
  height: '33px',
  color: ({ palette }) => palette.text.primary,
  borderRadius: '50%',
  border: ({ palette }) => `1px solid ${palette.border.default}`,
  backgroundColor: ({ palette }) => palette.background.paper,

  ...customStyles,
});

export const initialsStyles = {
  fontWeight: 500,
};
